// extracted by mini-css-extract-plugin
module.exports = {"menu":"BottomMenu_menu__V0_6J"};